import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { multiRowSelection } from '../agGridRowSelection';
////import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import { themeQuartz } from 'ag-grid-community'; //import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { useParams, useLocation } from "react-router-dom";
import { NavLink} from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react'
import { Flex, Divider, View, Text, Heading, Button, SelectField, TextField} from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import Loadingmini from '../components/loadingmini';
import TableViewSelector from "../components/tableViewSelector";
import Vehicleonboard from "../components/vehicleonboard";
import { fetchPaginatedAgoList } from '../paginatedAgoFetch';

export default function Assets() {
    let params = useParams();
    const location = useLocation();
    const fetchGenerationRef = useRef(0);
    const inFlightKeyRef = useRef(null);
    const [selected_fleet, updateSelectedFleet] = React.useState([]);
    const [tableData, updateTableData] = useState([])
    const [is_loading, updateIsLoading] = React.useState(false);
    const [is_loading_more_entries, updateIsLoadingMoreEntries] = React.useState(true);
    const [isLoadingGrid, updateIsLoadingGrid] = React.useState(false);
    const [displayAdministrativeFunctions, updateDisplayAdministrativeFunctions] = React.useState(false);
    const [displaySuperAdministrativeFunctions, updateDisplaySuperAdministrativeFunctions] = React.useState(false);
    const [isInsurerUsertype, updateIsInsurerUsertype] = React.useState(false);
    const [tablePivotMode, updateTablePivotMode] = React.useState(false);
    const gridRef = useRef(null);
    const [tableColumns, updateTableColumns] = React.useState([{}]);
    const [show_retired, updateShowRetired] = React.useState("false");
    const [WebPageDateRangeLabel, updateWebPageDateRangeLabel] = React.useState("");
    const [loadError, updateLoadError] = React.useState("");

    
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const fleetsParam = params.get("fleets");
        if (fleetsParam) {
            updateSelectedFleet(fleetsParam.split(","));
        } else {
            updateSelectedFleet([]);
        }
    }, [location.search]);
    

    function handleupdateShowRetired(val)
    {
        updateShowRetired(val)
        fetchPageData(selected_fleet[0], val, { force: true })
    }

    async function getJwtToken() {
        let retries = 5;
        let token = null;
        
        while (retries > 0) {
            try {
            const session = await Auth.currentSession();     
            var accessToken = session.getAccessToken()
            token = accessToken.getJwtToken()
            if (token) break; // valid token ready
            } catch (e) {
            // Auth not ready yet
            console.log("Auth not ready, retrying...", e);
            }
            retries--;
            await new Promise(res => setTimeout(res, 500)); // wait 0.5s before retry
        }
        if (!token) throw new Error("Unable to get a valid JWT token from Auth");



        if(accessToken.payload)
        {
            if(accessToken.payload["cognito:groups"])
            {
                if(accessToken.payload["cognito:groups"][0]==='admin')
                {
                    updateDisplayAdministrativeFunctions(true)
                    updateDisplaySuperAdministrativeFunctions(true)
                } else {
                    if(accessToken.payload["cognito:groups"][0]==='support'||accessToken.payload["cognito:groups"][0]==='fleet')
                    {
                        updateDisplayAdministrativeFunctions(true)
                    } else {
                        if(accessToken.payload["cognito:groups"][0]==='insurer')
                        {
                            updateIsInsurerUsertype(true)
                        }
                    }
                }
            }
        }
        return token;
    }

    function failPageLoad(message, generation, flightKey) {
        if (generation !== fetchGenerationRef.current) return;
        if (inFlightKeyRef.current === flightKey) {
            inFlightKeyRef.current = null;
        }
        console.error('error loading assets:', message);
        updateTableData([]);
        updateLoadError(message);
        updateIsLoading(false);
        updateIsLoadingMoreEntries(false);
    }

    async function fetchPageData(tSelectedFleet, tShowRetired, { force = false } = {}) {
        var thisFleet = tSelectedFleet ?? selected_fleet[0] ?? "";
        var thisShowRetired = "false"     
        if(!tShowRetired)
        {
            thisShowRetired = show_retired
        } else {
            thisShowRetired = tShowRetired
        }
        if(!thisFleet)
        {
            thisFleet = ""
        }
        const flightKey = `${thisFleet || "__none__"}:${thisShowRetired}`;
        if (!force && inFlightKeyRef.current === flightKey) {
            console.log('skipping duplicate assets fetch for '+flightKey);
            return;
        }

        const generation = ++fetchGenerationRef.current;
        inFlightKeyRef.current = flightKey;
        console.log('fetching page data...')
        updateLoadError("");
        try {
            await getJwtToken();
        } catch (e) {
          console.error("Cannot fetch page data: ", e);
          failPageLoad("Unable to get a valid login session. Please sign in again.", generation, flightKey);
          return;
        }
        updateIsLoading(true)
        updateIsLoadingMoreEntries(true)
        updateTableData([])
        console.log('fleet: '+thisFleet);

        const baseParams = {
            api_endpoint: "api3:staff:vehicles_catalog",
        };
        if (thisFleet !== "") {
            baseParams.fleet_code = thisFleet;
        }
        if (thisShowRetired === "true") {
            baseParams.show_retired = true;
        }

        const result = await fetchPaginatedAgoList(baseParams, {
            onProgress: (items, meta) => {
                if (generation !== fetchGenerationRef.current) return;
                updateTableData(items);
                if (items.length > 0) {
                    updateIsLoading(false);
                }
                if (meta?.done) {
                    updateIsLoadingMoreEntries(false);
                }
            },
        });
        if (generation !== fetchGenerationRef.current) {
            return;
        }
        if (inFlightKeyRef.current === flightKey) {
            inFlightKeyRef.current = null;
        }
        if (!result.ok) {
            failPageLoad(result.error, generation, flightKey);
            return;
        }

        let webPageDateRL = "";
        for (const row of result.items) {
            if (row && row.WebPageDateRangeLabel) {
                webPageDateRL = row.WebPageDateRangeLabel;
                break;
            }
        }
        updateWebPageDateRangeLabel(webPageDateRL);
        updateTableData(result.items);
        console.log('all pages loaded, rows='+result.items.length)
        updateIsLoading(false)
        updateIsLoadingMoreEntries(false)
    }

    const selectedFleetCode = selected_fleet[0] ?? "";
    useEffect(() => {
        if (selectedFleetCode) {
            fetchPageData(selectedFleetCode);
        }
    }, [selectedFleetCode]);

    const filtersReady = !is_loading_more_entries && !is_loading;
    const gridColumnDefs = filtersReady
        ? tableColumns
        : (tableColumns || []).map((col) => ({
            ...col,
            filter: false,
            floatingFilter: false,
          }));
    
    const blankAgg = (params) => {
        const values = params.values?.filter(v => v !== null && v !== undefined);
        if (!values || values.length === 0) return null;
        const uniqueValues = [...new Set(values)];

        // If exactly one unique value, show it
        if (uniqueValues.length === 1) {
            return uniqueValues[0];
        }

        // Otherwise, show count
        //const count = values.length;
        //return `${count} value${count === 1 ? "" : "s"}`;
        return null;
    };
    

    return(
        <Flex   //  https://ui.docs.amplify.aws/react/components/flex#demo
            direction='column'      //direction={{ base: 'column', large: 'row' }}
            //justifyContent='normal'           justifyContent={{ base: 'flex-start', large: 'flex-start' }}        //justifyContent="center"
            //alignItems='stretch'              alignItems={{ base: 'stretch', large: 'flex-start' }}       //alignItems="center" // alignItems="flex-end" (right)
            //alignContent='normal'             alignContent="flex-start"       //alignContent="center"
            wrap="wrap" //nowrap
            gap="1rem"
        >
            <View style={{padding:"1rem"}}>
                <Flex
                    direction='column'
                >
                    <Heading level={1}>Assets</Heading>
                    <Text>The vehicles associated with your fleet, even if they haven't been on the road yet. Click the blue link to see detailed diagnostics on any vehicle. {WebPageDateRangeLabel !== "" ? WebPageDateRangeLabel : "All metrics are for the most recent 7-day period."}</Text>
                    <View>
                        <Button onClick={() => fetchPageData(undefined, undefined, { force: true })}>
                            PRESS TO GET LATEST UPDATES
                        </Button>
                    </View>
                    <Divider />
                    {loadError ? (
                        <Text color="red">{loadError}</Text>
                    ) : (
                        is_loading_more_entries ? <Text><i>Some data is still loading{tableData.length ? ` (${tableData.length} so far)` : ''}... Filters unlock when complete.</i></Text> : <Text><i>Hint: To search, long-click on mobile or click top-right on pc.</i></Text>
                    )}
                    {loadError ? null :
                    is_loading ? <Loadingmini /> : 
                    !selected_fleet ? <Loadingmini /> :
                    selected_fleet == "" ? <Loadingmini /> :
                        <Flex direction="column">
                            <Flex 
                                direction="row" 
                                wrap="wrap" 
                                style={{ width: '80vw', minWidth: '450px', maxWidth: '2200px' }} 
                                alignItems="center" 
                                gap="1rem"
                            >
                                {show_retired === "false" ? (
                                    <Button onClick={() => handleupdateShowRetired("true")}>
                                        VIEW RETIRED VEHICLES
                                    </Button>
                                ) : (
                                    <Button onClick={() => handleupdateShowRetired("false")}>
                                        HIDE RETIRED VEHICLES
                                    </Button>
                                )}

                                {/* Right-aligned ADD VEHICLE button */}
                                {displayAdministrativeFunctions && (
                                    <Vehicleonboard
                                        fleetCode={selected_fleet[0]}
                                        refreshParent={() => fetchPageData(undefined, undefined, { force: true })}
                                        style={{ marginLeft: 'auto' }} // pushes it to the right
                                    />
                                )}
                            </Flex>

                            <Flex wrap="wrap" gap="2rem" >
                                <Flex direction="column" style={{ width: '80vw', minWidth: '450px', maxWidth: '2200px' }}>
                                    <Divider />
                                    {(displayAdministrativeFunctions || isInsurerUsertype) && !isLoadingGrid && (
                                        <TableViewSelector
                                            fetchPageData={() => fetchPageData(undefined, undefined, { force: true })}
                                            tableType="vehicles"
                                            gridRef={gridRef}
                                            updateTableColumns={updateTableColumns}
                                            updateTablePivotMode={updateTablePivotMode}
                                            displaySideDock={false}
                                            selectObject={() => {}}
                                            selectedFleets={selected_fleet[0] ?? ""}
                                            configReady={filtersReady}
                                        />
                                    )}
                                    <View 
                                        theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                                        style={{ height: 750 }} // the grid will fill the size of the parent container
                                    >
                                        <AgGridReact
                                            ref={gridRef}
                                            onGridReady={params => {
                                                console.log('onGridReady');
                                                updateIsLoadingGrid(false);
                                            }}
                                            rowData={tableData}
                                            columnDefs={gridColumnDefs}
                                            aggFuncs={{
                                                blankAgg: blankAgg
                                            }}
                                            defaultColDef={{
                                                enableRowGroup: true,
                                                sortable: true,
                                                filter: filtersReady,
                                                floatingFilter: false,
                                                autoHeaderHeight: true,
                                                wrapHeaderText: true,
                                                aggFunc: 'blankAgg'
                                            }}
                                            rowSelection={multiRowSelection}
                                            pagination={true}
                                            paginationPageSize={25}
                                            paginationPageSizeSelector={[10, 25, 50]}
                                            rowBuffer={5}
                                            enableCellTextSelection={true}
                                            suppressRowVirtualisation={false}
                                            pivotMode={tablePivotMode} 
                                            suppressAggFuncInHeader={true}
                                            sideBar={{
                                                toolPanels: [
                                                  {
                                                    id: "columns",
                                                    labelDefault: "Columns",
                                                    labelKey: "columns",
                                                    iconKey: "columns",
                                                    toolPanel: "agColumnsToolPanel",
                                                  },
                                                ],
                                                defaultToolPanel: null, // 👈 THIS keeps it closed on load
                                              }}
                                            //pivotPanelShow={"always"}
                                            grandTotalRow={"bottom"}
                                        />
                                    </View>
                                    <Divider />
                                </Flex>
                            </Flex>
                        </Flex>
                    }
                </Flex>
            </View>
        </Flex> 
    );
}
